import BaseValidator from 'services/validations/base-validator';
import {interpret} from 'dictionary';
import {RuleItemInterface} from '../interfaces';
import KeyStatementObjectIsChosenValidator from './key-statement-object-is-chosen-validator';
import BoostStatementsValidator from './boost-statements-validator';
import PlayersNotDuplicatedValidator from './players-not-duplicated-validator';
import PositionsNotDuplicatedValidator from './positions-not-duplicated-validator';
import KeyStatementObjectsNotDuplicatedValidator from './key-statement-objects-not-duplicated-validator';
import KeyPlayerTierNotDuplicatedInBoostStatementTiersValidator from './key-player-tier-not-duplicated-in-boost-statement-tiers-validator';

class Validator extends BaseValidator {
    private ruleName: string = interpret('projection boost rule');

    protected runValidation(): void {
        // @ts-ignore
        const {ruleItem, sportConfig, players} = this.dependencies;

        this.validateKeyStatementObjectIsChosen(ruleItem);
        this.validateBoostStatements(ruleItem);
        this.validatePlayersNotDuplicated(ruleItem);
        this.validateKeyStatementObjectsNotDuplicated();

        if (sportConfig.isGameTypeTiers()) {
            this.validateKeyPlayerTierNotDuplicatedInBoostStatementTiers(ruleItem, players);
        } else if (sportConfig.isGameTypeClassic()) {
            this.validatePositionsNotDuplicated(ruleItem);
        }
    }

    private validateKeyStatementObjectIsChosen(ruleItem: RuleItemInterface): void {
        const validator = new KeyStatementObjectIsChosenValidator();
        validator.setDependencies({ruleItem, ruleName: this.ruleName});

        !validator.validate() && this.addError(validator.getFirstError());
    }

    private validateBoostStatements(ruleItem: RuleItemInterface): void {
        const validator = new BoostStatementsValidator();
        validator.setDependencies({ruleItem, ruleName: this.ruleName});

        !validator.validate() && this.addError(validator.getFirstError());
    }

    private validatePlayersNotDuplicated(ruleItem: RuleItemInterface): void {
        const validator = new PlayersNotDuplicatedValidator();
        validator.setDependencies({ruleItem, ruleName: this.ruleName});

        !validator.validate() && this.addError(validator.getFirstError());
    }

    private validatePositionsNotDuplicated(ruleItem: RuleItemInterface): void {
        const validator = new PositionsNotDuplicatedValidator();
        validator.setDependencies({ruleItem, ruleName: this.ruleName});

        !validator.validate() && this.addError(validator.getFirstError());
    }

    private validateKeyStatementObjectsNotDuplicated(): void {
        const validator = new KeyStatementObjectsNotDuplicatedValidator();
        validator.setDependencies({...this.dependencies, ruleName: this.ruleName});

        !validator.validate() && this.addError(validator.getFirstError());
    }

    private validateKeyPlayerTierNotDuplicatedInBoostStatementTiers(ruleItem: RuleItemInterface, players): void {
        const validator = new KeyPlayerTierNotDuplicatedInBoostStatementTiersValidator();
        validator.setDependencies({ruleItem, players, ruleName: this.ruleName});

        !validator.validate() && this.addError(validator.getFirstError());
    }
}

export default Validator;
